// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-ResetPassword-styles___pageLogin--LmBtk {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___card--cgtK4 {
    width: 100%;
    max-width: 450px;
    padding: 32px;
  }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___card--cgtK4 .pages-ResetPassword-styles___cardContent--h6Bjp {
      padding: 0 !important;
    }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___card--cgtK4 .pages-ResetPassword-styles___title--Cjmbi {
      font-size: 25px;
      color: #1b2432;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
      margin-bottom: 10px;
    }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___card--cgtK4 .pages-ResetPassword-styles___button--QhhcG {
      margin: 16px 0 0;
    }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___card--cgtK4 .pages-ResetPassword-styles___dHaveAccount--pY901 {
      margin-top: 20px;
      font-size: 14px;
    }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___card--cgtK4 .pages-ResetPassword-styles___dHaveAccount--pY901 .pages-ResetPassword-styles___signUp--is33K {
        font-weight: bold;
        text-decoration: underline;
      }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___card--cgtK4 .pages-ResetPassword-styles___loginError--_HmBo {
      color: red;
      text-align: center;
      font-size: 12px;
      padding: 10px 0;
    }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___textField--ujLxe button {
      padding: 0 !important;
    }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___icon--NN1Vl {
    width: 19px;
    height: 19px;
  }

  .pages-ResetPassword-styles___pageLogin--LmBtk .pages-ResetPassword-styles___eyeVisible--sQbQO {
    fill: #318afb;
  }

.pages-ResetPassword-styles___subTitle--D3Unq {
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 28px;
}
`, "",{"version":3,"sources":["webpack://./pages/ResetPassword/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AAuDf;;EArDE;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;EAkCf;;EAhCE;MACE,qBAAqB;IACvB;;EAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;IACrB;;EAEA;MACE,gBAAgB;IAClB;;EAEA;MACE,gBAAgB;MAChB,eAAe;IAKjB;;EAJE;QACE,iBAAiB;QACjB,0BAA0B;MAC5B;;EAGF;MACE,UAAU;MACV,kBAAkB;MAClB,eAAe;MACf,eAAe;IACjB;;EAIA;MACE,qBAAqB;IACvB;;EAGF;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;AAGF;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".pageLogin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n\n  .card {\n    width: 100%;\n    max-width: 450px;\n    padding: 32px;\n\n    .cardContent {\n      padding: 0 !important;\n    }\n\n    .title {\n      font-size: 25px;\n      color: #1b2432;\n      letter-spacing: 0;\n      text-align: center;\n      font-weight: 500;\n      margin-bottom: 10px;\n    }\n\n    .button {\n      margin: 16px 0 0;\n    }\n\n    .dHaveAccount {\n      margin-top: 20px;\n      font-size: 14px;\n      .signUp {\n        font-weight: bold;\n        text-decoration: underline;\n      }\n    }\n\n    .loginError {\n      color: red;\n      text-align: center;\n      font-size: 12px;\n      padding: 10px 0;\n    }\n  }\n\n  .textField {\n    button {\n      padding: 0 !important;\n    }\n  }\n\n  .icon {\n    width: 19px;\n    height: 19px;\n  }\n\n  .eyeVisible {\n    fill: #318afb;\n  }\n}\n\n.subTitle {\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  text-align: center;\n  margin-bottom: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageLogin": `pages-ResetPassword-styles___pageLogin--LmBtk`,
	"card": `pages-ResetPassword-styles___card--cgtK4`,
	"cardContent": `pages-ResetPassword-styles___cardContent--h6Bjp`,
	"title": `pages-ResetPassword-styles___title--Cjmbi`,
	"button": `pages-ResetPassword-styles___button--QhhcG`,
	"dHaveAccount": `pages-ResetPassword-styles___dHaveAccount--pY901`,
	"signUp": `pages-ResetPassword-styles___signUp--is33K`,
	"loginError": `pages-ResetPassword-styles___loginError--_HmBo`,
	"textField": `pages-ResetPassword-styles___textField--ujLxe`,
	"icon": `pages-ResetPassword-styles___icon--NN1Vl`,
	"eyeVisible": `pages-ResetPassword-styles___eyeVisible--sQbQO`,
	"subTitle": `pages-ResetPassword-styles___subTitle--D3Unq`
};
module.exports = ___CSS_LOADER_EXPORT___;
